import React from 'react';
import QuestionnaireView from 'views/QuestionnaireView';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setResult } from 'state/actions/questionnaireActions';

class QuestionnaireContainer extends React.Component {
  render() {
    return <QuestionnaireView
             setResult={this.props.actions.setResult}
             questions={this.props.questions}
             results={this.props.results} />;
  }
}

function mapStateToProps(state) {
  return {
    results: state.questionnaireState.results,
    questions: state.questionnaireState.questions
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setResult
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireContainer);



// WEBPACK FOOTER //
// ./src/containers/QuestionnaireContainer.js